import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const HeaderBand = styled.div`
  position: relative;
  background: ${vimovaTheme.colors.primary};
  border-radius: ${vimovaTheme.borderRadius.signatureLarge};
  padding: 40px 40px 48px 40px;
  overflow: hidden;

  @media print {
    background: ${vimovaTheme.colors.primary} !important;
    border-radius: ${vimovaTheme.borderRadius.signatureLarge} !important;
    padding: 40px 40px 48px 40px !important;
    overflow: hidden !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeaderTitle = styled.h1`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 28px;
  color: ${vimovaTheme.colors.white};
  margin: 0 0 8px 0;
  position: relative;
  z-index: 1;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 28px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeaderSubtitle = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  position: relative;
  z-index: 1;

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: rgba(255, 255, 255, 0.6) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeaderDecoration = styled.div`
  position: absolute;
  bottom: -10px;
  right: -10px;
  opacity: 0.15;

  @media print {
    position: absolute !important;
    bottom: -10px !important;
    right: -10px !important;
    opacity: 0.15 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TOCList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 24px 8px 0 8px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    padding: 24px 8px 0 8px !important;
  }
`

export const TOCEntry = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;

  @media print {
    display: flex !important;
    align-items: center !important;
    padding: 8px 0 !important;
  }
`

export const TOCNumber = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${vimovaTheme.colors.orange};
  min-width: 48px;
  flex-shrink: 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TOCTitle = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.textDark};
  flex-shrink: 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TOCLeader = styled.span`
  flex: 1;
  border-bottom: 1px dashed ${vimovaTheme.colors.border};
  margin: 0 12px;
  min-width: 20px;
  align-self: center;
  height: 0;

  @media print {
    flex: 1 !important;
    border-bottom: 1px dashed ${vimovaTheme.colors.border} !important;
    margin: 0 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TOCPage = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: ${vimovaTheme.fontWeights.normal};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.textMuted};
  flex-shrink: 0;
  min-width: 20px;
  text-align: right;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.normal} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GreenBracketDecoration = styled.div`
  position: absolute;
  bottom: 60px;
  right: 20px;
  opacity: 0.3;

  @media print {
    position: absolute !important;
    bottom: 60px !important;
    right: 20px !important;
    opacity: 0.3 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
